var map = {
	"./Player/images/play_effect_selected_item.png": 824,
	"./Player/images/play_effect_start_game.png": 825,
	"./Player/images/player_0.png": 826,
	"./Player/images/player_1.png": 827,
	"./Player/images/player_2.png": 828,
	"./Player/images/player_20p.png": 829,
	"./Player/images/player_3.png": 830,
	"./Player/images/player_30p.png": 831,
	"./Player/images/player_4.png": 832,
	"./Player/images/player_40p.png": 833,
	"./Player/images/player_5.png": 834,
	"./Player/images/player_50p.png": 835,
	"./Player/images/player_6.png": 836,
	"./Player/images/player_7.png": 837,
	"./Player/images/player_8.png": 838,
	"./Player/images/player_9.png": 839,
	"./Player/images/player_back.png": 840,
	"./Player/images/player_background.jpg": 841,
	"./Player/images/player_bg_ancient.png": 842,
	"./Player/images/player_bird.png": 843,
	"./Player/images/player_capture.png": 844,
	"./Player/images/player_crock.png": 845,
	"./Player/images/player_level.png": 846,
	"./Player/images/player_level_A.png": 847,
	"./Player/images/player_level_B.png": 848,
	"./Player/images/player_level_C.png": 849,
	"./Player/images/player_level_D.png": 850,
	"./Player/images/player_level_S.png": 851,
	"./Player/images/player_levelup.png": 852,
	"./Player/images/player_lock.png": 853,
	"./Player/images/player_lock2.png": 854,
	"./Player/images/player_space.png": 855,
	"./Player/images/player_start.png": 856,
	"./Player/images/player_win.png": 857,
	"./Score/images/score_0.png": 858,
	"./Score/images/score_1.png": 859,
	"./Score/images/score_2.png": 860,
	"./Score/images/score_3.png": 861,
	"./Score/images/score_4.png": 862,
	"./Score/images/score_5.png": 863,
	"./Score/images/score_6.png": 864,
	"./Score/images/score_7.png": 865,
	"./Score/images/score_8.png": 866,
	"./Score/images/score_9.png": 867,
	"./Score/images/score_aLOSE.png": 868,
	"./Score/images/score_aWIN.png": 869,
	"./Score/images/score_back.jpg": 870,
	"./Score/images/score_back_btn.png": 871,
	"./Score/images/score_capture.png": 872,
	"./Score/images/score_lose.png": 873,
	"./Score/images/score_pointl.png": 874,
	"./Score/images/score_pointw.png": 875,
	"./Score/images/score_space.png": 876,
	"./Score/images/score_win.png": 877,
	"./images/0.png": 878,
	"./images/0B.png": 879,
	"./images/1.png": 880,
	"./images/1B.png": 881,
	"./images/2.png": 882,
	"./images/2B.png": 883,
	"./images/3.png": 884,
	"./images/3B.png": 885,
	"./images/4.png": 886,
	"./images/4B.png": 887,
	"./images/5.png": 888,
	"./images/5B.png": 889,
	"./images/6.png": 890,
	"./images/6B.png": 891,
	"./images/7.png": 892,
	"./images/7B.png": 893,
	"./images/8.png": 894,
	"./images/8B.png": 895,
	"./images/9.png": 896,
	"./images/9B.png": 897,
	"./images/Death.png": 898,
	"./images/LOSE.png": 899,
	"./images/Win.png": 900,
	"./images/b_icon_01.png": 901,
	"./images/b_icon_02.png": 902,
	"./images/b_icon_03.png": 903,
	"./images/b_icon_04.png": 904,
	"./images/b_icon_05.png": 905,
	"./images/backbtn.png": 906,
	"./images/bcur.png": 907,
	"./images/birdbig.png": 908,
	"./images/birdplay.png": 909,
	"./images/blose.png": 910,
	"./images/board.png": 911,
	"./images/buttonr.png": 912,
	"./images/buttony.png": 913,
	"./images/ccur.png": 914,
	"./images/crocobig.png": 915,
	"./images/crocoplay.png": 916,
	"./images/dot.png": 917,
	"./images/effect_excellent.png": 918,
	"./images/effect_fantastic.png": 919,
	"./images/effect_start.png": 920,
	"./images/effect_triple.png": 921,
	"./images/fightbutton.png": 922,
	"./images/finish.png": 923,
	"./images/fire_board.png": 924,
	"./images/fire_shoot.png": 925,
	"./images/firebird.png": 926,
	"./images/firecro.png": 927,
	"./images/frame.png": 928,
	"./images/gameplay_bg_01.jpg": 929,
	"./images/gameplay_bg_02.jpg": 930,
	"./images/gameplay_bg_03.jpg": 931,
	"./images/gameplay_bg_04.jpg": 932,
	"./images/gameplay_bg_05.jpg": 933,
	"./images/gameplay_bg_ancient.jpg": 934,
	"./images/gameplay_bg_b_01.png": 935,
	"./images/gameplay_bg_b_02.png": 936,
	"./images/gameplay_bg_b_03.png": 937,
	"./images/gameplay_bg_b_04.png": 938,
	"./images/gameplay_bg_b_05.png": 939,
	"./images/getPointEffect.png": 940,
	"./images/loadstart.png": 941,
	"./images/minus.png": 942,
	"./images/pass.png": 943,
	"./images/pass2.png": 944,
	"./images/playagain.png": 945,
	"./images/playb.png": 946,
	"./images/playw.png": 947,
	"./images/pointb.png": 948,
	"./images/pointw.png": 949,
	"./images/s_big_01.png": 950,
	"./images/s_big_02.png": 951,
	"./images/s_big_03.png": 952,
	"./images/s_big_04.png": 953,
	"./images/s_cur_01.png": 954,
	"./images/s_cur_02.png": 955,
	"./images/s_cur_03.png": 956,
	"./images/s_cur_04.png": 957,
	"./images/s_icon_01.png": 958,
	"./images/s_icon_02.png": 959,
	"./images/s_icon_03.png": 960,
	"./images/s_icon_04.png": 961,
	"./images/s_nor_01.png": 962,
	"./images/s_nor_02.png": 963,
	"./images/s_nor_03.png": 964,
	"./images/s_nor_04.png": 965,
	"./images/starbigr.png": 966,
	"./images/starbigy.png": 967,
	"./images/start.png": 968,
	"./images/t_big_01.png": 969,
	"./images/t_big_02.png": 970,
	"./images/t_big_03.png": 971,
	"./images/t_big_04.png": 972,
	"./images/t_cur_01.png": 973,
	"./images/t_cur_02.png": 974,
	"./images/t_cur_03.png": 975,
	"./images/t_cur_04.png": 976,
	"./images/t_icon_01.png": 977,
	"./images/t_icon_02.png": 978,
	"./images/t_icon_03.png": 979,
	"./images/t_icon_04.png": 980,
	"./images/t_nor_01.png": 981,
	"./images/t_nor_02.png": 982,
	"./images/t_nor_03.png": 983,
	"./images/t_nor_04.png": 984,
	"./images/undo.png": 985
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 823;